import RippleLoaderLines from './RippleLoaderLines';
import { StyledHr, StyledKeylineDiv } from './Styled';
import TariffRateTableSection from './TariffRateTableSection';

const TariffRateTable = ({ rates, keyLine = false, loading = false }) => {
  return loading ? (
    <StyledKeylineDiv>
      <RippleLoaderLines lines={4} />
    </StyledKeylineDiv>
  ) : (
    <>
      <div className="d-none d-sm-block">
        <TariffRateTableSection keyLine={keyLine} rates={rates} columns={['import', 'export']} wrapperClass="pb-0" />
      </div>
      <div className="d-block d-sm-none">
        <TariffRateTableSection keyLine={keyLine} rates={rates} columns={['import']} wrapperClass="mb-4" />
        {!keyLine && <StyledHr />}
        <TariffRateTableSection keyLine={keyLine} rates={rates} columns={['export']} />
      </div>
    </>
  );
};

export default TariffRateTable;
